module.exports = {"app_name":"restaurants-socialbar","notifications":{"slack_channels":["restaurants-urgent"]},"deploy_annotations":["restaurants-socialbar-ssr"],"interactions":{},"app_ipm_scale":3}


//////////////////
// WEBPACK FOOTER
// ../fedops.json
// module id = 747
// module chunks = 0